import { render } from "./CustomUpload.vue?vue&type=template&id=75f70db8"
import script from "./CustomUpload.vue?vue&type=script&lang=js"
export * from "./CustomUpload.vue?vue&type=script&lang=js"

import "./CustomUpload.vue?vue&type=style&index=0&id=75f70db8&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__